<div class="picker-wrapper flex">
	<ngx-mat-timepicker-field [format]="24" [defaultTime]="!isRange ? formatSecondsToHhMm(value) : formatSecondsToHhMm(rangeValue[0])" (timeChanged)="onTimeChangedChange($event)"></ngx-mat-timepicker-field>
	<ngx-mat-timepicker-field *ngIf="isRange" [format]="24" [defaultTime]="formatSecondsToHhMm(rangeValue[1])" (timeChanged)="onTimeChangedChange($event, true)"></ngx-mat-timepicker-field>
</div>
